<div class="container-templates">
  <h1 class="title">{{ 'TEMPLATES' | translate }}</h1>

  <div class="form-card p-4 mb-5">
    <ul class="nav nav-tabs templates-tabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          type="button"
          class="nav-link"
          [class.active]="activeTemplateTab === 'email'"
          (click)="selectTemplateTab('email')">
          {{ 'EMAIL_TEMPLATE_EDITOR' | translate }}
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          type="button"
          class="nav-link"
          [class.active]="activeTemplateTab === 'checkout'"
          (click)="selectTemplateTab('checkout')">
          {{ 'CHECKOUT_TEMPLATE' | translate }}
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          type="button"
          class="nav-link"
          [class.active]="activeTemplateTab === 'product'"
          (click)="selectTemplateTab('product')">
          {{ 'PRODUCT_TEMPLATE' | translate }}
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          type="button"
          class="nav-link"
          [class.active]="activeTemplateTab === 'medical'"
          (click)="selectTemplateTab('medical')">
          {{ 'MEDICAL_HISTORY_TAB' | translate }}
        </button>
      </li>
    </ul>

    <div class="templates-tab-content">
      <div [hidden]="activeTemplateTab !== 'email'">
        <app-email-template-editor></app-email-template-editor>
      </div>
      <div [hidden]="activeTemplateTab !== 'checkout'">
        <app-checkout-template-editor></app-checkout-template-editor>
      </div>
      <div [hidden]="activeTemplateTab !== 'product'">
        <app-product-view-template-editor></app-product-view-template-editor>
      </div>
      <div *ngIf="medicalHistoryTabVisited" [hidden]="activeTemplateTab !== 'medical'">
        <app-medical-history-visibility-settings></app-medical-history-visibility-settings>
      </div>
    </div>
  </div>
</div>
